import React from 'react';
import { Link } from 'react-router-dom';

import '../styles/pill.css';

const Pill = ({ label, icon = null, active = false, onClick = null, to = null, variant = null }) => {
    const className = `pill ${active ? "active " : ""}${variant ? `pill--${variant}` : ""}`.trim();

    const content = (
        <>
            { icon && (
                <img
                    className="pill-icon"
                    src={`${process.env.PUBLIC_URL}/assets/icons/categories/${icon}.svg`}
                />
            ) }
            { label }
        </>
    );

    if(onClick) {
        return (
            <button
                type="button"
                className={className}
                aria-pressed={active}
                onClick={onClick}
            >
                { content }
            </button>
        );
    }

    if(to) {
        return (
            <Link className={className} to={to}>
                { content }
            </Link>
        );
    }

    return (
        <span className={className}>
            { content }
        </span>
    );
};

export default Pill;
